import React from 'react'
import allan from './img/allan.png'
import Navbar from './Navbar'

const NotFound = () => {
  return (
    <div>
      <Navbar />
      <div className="container-fluid bg-white center">
        <h1>Sorry, the page you requested was not found</h1>
        <p className="lead-text">Please check the URL for proper spelling.</p>
        <p className="lead-text padding">
          If you're having trouble try contacting{' '}
          <a href="https://tlrg.com.au/pages/contact-us">
            The Learning Resources Group
          </a>{' '}
          or go back to the{' '}
          <a href="https://tlrg.com.au/pages/lln-robot">
            LLN Robot Information Page
          </a>
        </p>
        <img src={allan} alt="" />
      </div>
    </div>
  )
}

export default NotFound



// WEBPACK FOOTER //
// ./src/NotFound.js